// extracted by mini-css-extract-plugin
export var bookDemoFooter = "FooterMenu-module--bookDemoFooter--6f159";
export var bottomContent = "FooterMenu-module--bottomContent--8fa75";
export var container = "FooterMenu-module--container--6970c";
export var icons = "FooterMenu-module--icons--25c76";